import { ClipboardClock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { TransactionsTable } from './components/transactions-table'
import { useTransactions } from './hooks/useTransaction'
import { useTransactionsStore } from './stores/transactions-store'
import { type GetTransactionHistoryResponse } from './types/transactions'

export function TransactionsDialog() {
  const { page, limit } = useTransactionsStore((state) => state.pagination)
  const { isOpen, setOpen } = useTransactionsStore((state) => state.dialog)
  
  const { transactionsQuery } = useTransactions({ page, limit })
  const { data, isLoading } = transactionsQuery
  
  // 生成的接口类型将 transactions 误标为 IdentityInviteRecord[]，运行时实为 TransactionRecord[]，故按本地正确类型断言
  const response = data?.data as unknown as
    | GetTransactionHistoryResponse['data']
    | undefined
  const transactions = response?.transactions ?? []
  const total = response?.pagination?.total ?? 0

  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant='ghost' size='icon' title='交易记录' className='scale-95 rounded-full'>
          <ClipboardClock className='h-4 w-4' />
        </Button>
      </DialogTrigger>
      
      <DialogContent className='max-w-4xl sm:max-w-[95vw] lg:max-w-5xl h-[95vh] sm:h-[85vh] flex flex-col p-0 overflow-hidden gap-0'>
        <DialogHeader className='p-6 pb-2'>
          <DialogTitle className='text-2xl font-bold tracking-tight'>交易记录</DialogTitle>
          <DialogDescription>
            查看您的充值、消费及收益记录
          </DialogDescription>
        </DialogHeader>
        
        <div className='flex-1 min-h-0 flex flex-col px-2 sm:px-6 pb-6 @container'>
          <TransactionsTable 
              data={transactions} 
              total={total} 
              loading={isLoading} 
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
